import "./App.css";

import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Packages from "./components/Packages/Packages";
import Trust from "./components/Trust/Trust";
import Security from "./components/Security/Security";

import AppSection from "./components/AppSection/AppSection";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Navbar />

      <main>
        <Hero />
        <Packages />
        <Trust />
        <Security />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}

export default App;
